import {Typography} from 'components/Typography';
import {FC} from 'react';
import style from './style.module.scss';

export const ShieldTastingHall: FC = () => {
    return (
        <button className={style.main} type={'button'}>
            <img alt={''} className={style.image} src={'/images/tastingHall.svg'} />
            <Typography className={style.title} variant={'button-14-m-cl'}>
                Дегустационный зал
            </Typography>
        </button>
    );
};
